import { Route, Routes } from 'react-router-dom';
import TeacherReport from '../pages';
import CourseUsage from '../pages/courseUsage';
import { AssignmentProvider } from '../../assignments/context';
import { ReportProvider } from '../components/reportContext';
import AllStudentsScoreInfo from '../pages/score/pages/allStudentsScoreInfo';
import SingleStudentScoreInfo from '../pages/score/pages/singleStudentScoreInfo';
import Responses from '../../../pages/assignments/pages/ManageAssign/components/Responses';
import TimeOnTask from '../pages/timeOnTaskReport';
import AllAssignmentsReport from '../pages/allAssignmentsReport';
import SingleAssessmentReport from '../pages/singleAssessmentReport';
import AssignmentCumulativeReport from '../../assignments/pages/ManageAssign/components/Reports/AssignmentCumulativeReport';
import AllAssignmentsCumilativeReport from '../pages/allAssignmentsReport/allAssignmentsCumulativeReport';
import GrowthReport from '../pages/growthReport';
import StudentSessionReport from '../../assignments/pages/ManageAssign/components/Reports/StudentSessionReport';
import MathSkillReportFilter from '../pages/mathSkillReport';
import MathSkillReport from '../../classes/pages/SessionsAndReport/Pages/mathSkillReport';
import ClassCumulativeReport from '../../assignments/pages/ManageAssign/components/Reports/ClassCumulativeReport';
import LoginTrackingFilter from '../pages/loginTrackingReport/filter';
import LoginActivityReport from '../pages/loginTrackingReport/loginActivityReport';
import LoginActivityTTReport from '../pages/loginTrackingReport/loginActivityTimeOnTaskReport';
import { ItemAnalysisProvider } from '../pages/itemAnalysis/utils/itemAnalysisContext';
import ItemAnalysis from '../pages/itemAnalysis/pages';
import ItemAnalysisReport from '../pages/itemAnalysis/pages/report';

const ReportRoute = () => {
  return ( 
    <div>
      <AssignmentProvider>
        <ReportProvider>
          <Routes>
            <Route path="/" element={<TeacherReport />} ></Route>        
            <Route path="/course-usage" element={<CourseUsage />} />
            <Route path="/all-admin-assessments" element={<AllAssignmentsReport />} />
            <Route path="/single-admin-assessment" element={<SingleAssessmentReport />} />
            <Route path="/all-assignments" element={<AllAssignmentsReport />} />
            <Route path="/single-assignment" element={<SingleAssessmentReport />} />
            <Route path="/growth-report" element={<GrowthReport />} />
            <Route path="/math-skills" element={<MathSkillReportFilter />} />
            <Route path="/item-analysis" element={<ItemAnalysisProvider><ItemAnalysis /></ItemAnalysisProvider>} />
            <Route path="/item-analysis/report" element={<ItemAnalysisProvider><ItemAnalysisReport /></ItemAnalysisProvider>} />
            
            <Route path="/classes/:Id/cumulativeReport" element={<ClassCumulativeReport />} />
            <Route path="single-admin-assessment/:Id/class_cumulative_report" element={<AssignmentCumulativeReport />} />
            <Route path="single-admin-assessment/:Id/student_session_report" element={<StudentSessionReport />} />

            <Route path="single-assignment/:Id/class_cumulative_report" element={<AssignmentCumulativeReport />} />
            <Route path="single-assignment/:Id/student_session_report" element={<StudentSessionReport />} />

            <Route path="all-assignments/single_student_score_info" element={<SingleStudentScoreInfo />} />
            <Route path="all-assignments/single_student_score_info/:Id/student_session_report" element={<StudentSessionReport />} />
            <Route path="all-assignments/single_student_score_info/responses/:assignmentId/:studentId" element={<Responses />} />
            <Route path="all-assignments/all_students_score_info" element={<AllStudentsScoreInfo />} />
            
            <Route path="all-admin-assessments/single_student_score_info" element={<SingleStudentScoreInfo />} />
            <Route path="all-admin-assessments/single_student_score_info/:Id/student_session_report" element={<StudentSessionReport />} />
            <Route path="all-admin-assessments/single_student_score_info/responses/:assignmentId/:studentId" element={<Responses />} />
            <Route path="all-admin-assessments/all_students_score_info" element={<AllStudentsScoreInfo />} />

            <Route path="all-admin-assessments/:Id/class_cumulative_report" element={<AllAssignmentsCumilativeReport />} />
            
            <Route path="all-assignments/:Id/class_cumulative_report" element={<AllAssignmentsCumilativeReport />} />

            <Route path="/math-skills/:courseId/:studentId/skillReport" element={<MathSkillReport />} />

            <Route path="/time-on-task-tracking" element={<TimeOnTask />} />
            
            <Route path="/login-tracking" element={<LoginTrackingFilter />} />
            <Route path="/login-tracking/activity-report" element={<LoginActivityReport />} />
            <Route path="/login-tracking/activity-report/timeontask-report" element={<LoginActivityTTReport />} />

          </Routes>
        </ReportProvider>
      </AssignmentProvider>
    </div>
  );
};
  
export default ReportRoute;